import React, { Component } from 'react';

class Profile extends Component {
  render() {
    return (
      <div>
        <h2>This is the profile page!!</h2>
      </div>
    );
  }
}

export default Profile;
